module.exports = "/static/assets/82f3a23157b2ab798ed5917e1cf29298.png";